import { lazy } from 'app/lazy'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import { OAuthRedirectUri } from '../constants'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
import { ProviderType } from '../types'
export const OAuthCallbackPage = lazy(() => import('./OAuthCallbackPage'))
export const ConnectionsPage = lazy(() => import('./ConnectionsPage'))
export const ConnectionsList = lazy(() => import('./ConnectionsList/ConnectionsList'))
export const ConnectionCreator = lazy(() => import('./ConnectionForm/ConnectionCreator'))
export const ConnectionFormManager = lazy(() => import('./ConnectionForm/ConnectionFormManager'))
export const ConnectionCanNotBeCreated = lazy(() => import('./ConnectionsList/ConnectionCanNotBeCreated'))

export const ConnectionsRoutes = {
  path: 'connections',
  element: (
    <LazyLoad>
      <AuthenticatedRoute element={<ConnectionsPage />} />
    </LazyLoad>
  ),
  children: [
    {
      index: true,
      element: (
        <LazyLoad>
          <ConnectionsList />
        </LazyLoad>
      )
    },
    {
      path: 'create',
      element: (
        <LazyLoad>
          <ConnectionCreator />
        </LazyLoad>
      )
    },
    {
      path: 'cant_create',
      element: (
        <LazyLoad>
          <ConnectionCanNotBeCreated />
        </LazyLoad>
      )
    },
    {
      path: 'edit/:id',
      element: (
        <LazyLoad>
          <ConnectionFormManager />
        </LazyLoad>
      )
    }
  ]
}

export const OAuthCallbackRoutes = [
  {
    path: OAuthRedirectUri.snowflake,
    element: (
      <LazyLoad>
        <OAuthCallbackPage />
      </LazyLoad>
    )
  },
  {
    path: OAuthRedirectUri.bigquery,
    element: (
      <LazyLoad>
        <OAuthCallbackPage />
      </LazyLoad>
    )
  },
  {
    path: OAuthRedirectUri[ProviderType.DATABRICKS_REST],
    element: (
      <LazyLoad>
        <OAuthCallbackPage />
      </LazyLoad>
    )
  },
  {
    path: OAuthRedirectUri[ProviderType.DATABRICKS_WAREHOUSE],
    element: (
      <LazyLoad>
        <OAuthCallbackPage />
      </LazyLoad>
    )
  }
]
